import TitleBar from '../../../Components/TitleBar/TitleBar';
import Master from '../../../Layouts/Master';

const Doashboard = () => {
  return (
    <Master>
      <TitleBar
        title='داشبورد'
        showCreateBtn={false}
        showFilterBtn={false}
        showBackBtn={false}
      />
      <div className='row'>
        <div className='col-12'>
          <h1 className='text-dark f-16 font-weight-bold text-center d-flex flex-row justify-content-center my-3'>
            سامانه مسابقات فدراسیون زورخانه ای
          </h1>
        </div>
      </div>
    </Master>
  );
};

export default Doashboard;
